export default __webpack_public_path__ + "static/media/logo-large.6e36f3c1.png";